import { format, parseISO, differenceInCalendarDays } from "date-fns";
import { nn as nnLocale, enGB } from "date-fns/locale";

export const locale = (lang) => (lang === "en" ? enGB : nnLocale);

export function nok(n, lang = "nn") {
  if (n == null || Number.isNaN(n)) return "–";
  const s = Math.round(n).toLocaleString("nb-NO").replace(/\u00a0/g, " ");
  return lang === "en" ? `NOK ${s}` : `${s} kr`;
}

export const toISO = (d) => (d ? format(d, "yyyy-MM-dd") : "");
export const fromISO = (s) => (s ? parseISO(s) : undefined);

export function fmtDate(iso, lang = "nn", pattern = "EEE d. MMM") {
  if (!iso) return "";
  const d = typeof iso === "string" ? parseISO(iso) : iso;
  const p = lang === "en" ? pattern.replace("d.", "d") : pattern;
  return format(d, p, { locale: locale(lang) });
}

export function fmtLong(iso, lang = "nn") {
  return fmtDate(iso, lang, lang === "en" ? "EEEE d MMMM yyyy" : "EEEE d. MMMM yyyy");
}

export function nightsBetween(ci, co) {
  if (!ci || !co) return 0;
  return differenceInCalendarDays(parseISO(co), parseISO(ci));
}

export function nightsLabel(n, lang = "nn") {
  if (lang === "en") return `${n} ${n === 1 ? "night" : "nights"}`;
  return `${n} ${n === 1 ? "natt" : "netter"}`;
}

export function guestsLabel(n, lang = "nn") {
  if (lang === "en") return `${n} ${n === 1 ? "guest" : "guests"}`;
  return `${n} ${n === 1 ? "gjest" : "gjester"}`;
}

export function fmtDateTime(iso, lang = "nn") {
  if (!iso) return "";
  return format(parseISO(iso), lang === "en" ? "d MMM yyyy, HH:mm" : "d. MMM yyyy, HH:mm", { locale: locale(lang) });
}
